/* eslint-disable react-hooks/rules-of-hooks */
import { useMount, useSearchParam } from 'react-use';
import { Social } from 'utils/enum';
import {
  clearYoutubeShareCookies,
  setShareCookie,
  setSharemediaKeyYoutubeCookie,
  setShareProviderCookie,
} from 'utils/shareCookie.util';

export const SharePostYoutube = () => {
  const code = useSearchParam('code') as string;

  const state = window.location.hash.split('&')[0].split('=')[1];
  const provider = Social.YOUTUBE;

  useMount(() => {
    clearYoutubeShareCookies();

    if (code) {
      setShareCookie('code', code);
    }

    setSharemediaKeyYoutubeCookie(state);
    setShareCookie('state', 'true');
    setShareProviderCookie(provider);
    window.close();
  });

  return (
    <div className="App">
      <header className="App-header"></header>
    </div>
  );
};
